module.exports = __webpack_public_path__ + "media/customizations/ranchlife/missing-3a63ee8db3d1944a778467750f6dc3cd.jpg";